export default __webpack_public_path__ + "static/bg-spacex--mobile-63b23fb6187ccfdf5ed5aa1b7359c511.webp";